import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LightboxImageComponent } from '../../../../content/lightbox-image/lightbox-image.component';
import {
  PLAY_ALONG_TRACKS,
  type PlayAlongGroup,
} from '../play-along-tracks-data';

@Component({
  selector: 'app-play-along-tracks-content',
  imports: [LightboxImageComponent],
  templateUrl: './play-along-tracks-content.component.html',
  styleUrl: './play-along-tracks-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayAlongTracksContentComponent {
  readonly groups: readonly PlayAlongGroup[] = PLAY_ALONG_TRACKS;
}
